import { Button } from "@/components/ui/button";
import { Shield, CheckCircle2, Clock, Award } from "lucide-react";
import { AnimatedSection } from "@/components/AnimatedSection";

const HeroCommercial = () => {
  const scrollToForm = () => {
    const formSection = document.getElementById('formulario');
    if (formSection) {
      formSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const trustBadges = [
    { icon: Shield, text: "Certificados SEC" },
    { icon: Award, text: "+16 años experiencia" },
    { icon: CheckCircle2, text: "+500 locales atendidos" },
    { icon: Clock, text: "Respuesta en 24hrs" },
  ];

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-32 md:pt-24">
      {/* Animated Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-dark-section via-dark-section/95 to-industrial-gray">
        <div className="absolute top-20 left-10 w-96 h-96 bg-primary/30 rounded-full blur-3xl animate-liquid-blob opacity-20" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-accent/20 rounded-full blur-3xl animate-liquid-blob-delayed opacity-20" />
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-4 py-24 md:py-32 lg:py-40">
        <div className="max-w-5xl mx-auto text-center">
          <AnimatedSection animation="fade-in">
            <h1 className="text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-montserrat font-bold text-white mb-6 leading-tight px-4">
              ¿Tu Local Comercial Está Seguro Eléctricamente?
            </h1>
          </AnimatedSection>

          <AnimatedSection animation="fade-in" delay={100}>
            <p className="text-base md:text-lg lg:text-xl text-white/80 mb-8 md:mb-10 max-w-3xl mx-auto leading-relaxed px-4">
              Evita Incendios, Multas SEC y Pérdidas de Equipos con Nuestro Mantenimiento Preventivo Certificado
            </p>
          </AnimatedSection>

          <AnimatedSection animation="scale-in" delay={200}>
            <div className="w-full md:w-auto max-w-lg mx-auto backdrop-blur-xl bg-primary/20 border-2 border-primary/40 rounded-2xl px-6 py-3 md:px-8 md:py-4 mb-8 md:mb-10 mt-4 md:mt-6">
              <p className="text-xl md:text-2xl lg:text-3xl font-montserrat font-bold text-white">
                Desde <span className="text-primary">$49.990</span>
              </p>
              <p className="text-xs md:text-sm text-white/70 mt-1 px-2">
                Incluye Levantamiento + Informe Técnico + Certificación
              </p>
            </div>
          </AnimatedSection>

          <AnimatedSection animation="slide-up" delay={300}>
            <div className="mt-4 md:mt-6">
              <Button
                onClick={scrollToForm}
                size="lg"
                className="glass-liquid-medium bg-primary/90 hover:bg-primary text-white text-base md:text-lg px-8 py-4 md:px-12 md:py-6 h-auto shadow-liquid-xl hover:shadow-liquid-2xl hover:scale-105 transition-all duration-300"
              >
                Solicita tu Revisión GRATIS
              </Button>
            </div>
          </AnimatedSection>

          {/* Trust Badges */}
          <AnimatedSection animation="fade-in" delay={400}>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-12 max-w-4xl mx-auto">
              {trustBadges.map((badge, index) => (
                <div
                  key={index}
                  className="backdrop-blur-xl bg-white/10 border border-white/20 rounded-2xl p-4 hover:bg-white/15 transition-all duration-300 hover:scale-105"
                >
                  <badge.icon className="w-8 h-8 text-primary mx-auto mb-2" />
                  <p className="text-sm text-white/90 font-medium">{badge.text}</p>
                </div>
              ))}
            </div>
          </AnimatedSection>
        </div>
      </div>
    </section>
  );
};

export default HeroCommercial;
